import { createSelector } from 'reselect';
import { type IStoreState } from '../../types/StoreState';

const selectLoadingModules = (state: IStoreState) => state.ui.loadingModules;

export const selectIsAppLoading = createSelector(selectLoadingModules, (loadingModules) => loadingModules.length > 0);
